export default "__VITE_ASSET__ClzM2l4i__"